export default __webpack_public_path__ + "static/media/fantasy-land-linear-template.3a27c0b9.png";